module.exports = __webpack_public_path__ + "img/9.0e69ed8e.jpg";